<template>
  <div class="dropdown_box">
    <div class="dropbtn_box">更多智能工具<i class="shareIcon"></i></div>
    <div class="dropdown-content-box">
          <a  v-for="(item,index) in list" :key="index" :href="item.href" target="_blank">{{item.text}}</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
        return {
          list: [
            // {
            //   text: 'AI配图魔改器',
            //   href:'//www.5118.com/aips'
            // },
            {
              text: '营销文案生成器',
              href:'//www.5118.com/copywriting'
            },
            {
              text: 'SEO优化精灵：TDK生成器',
              href:'//www.5118.com/seometa'
            },
            {
              text: '文本扩写精灵',
              href:'//www.5118.com/autoexpander'
            },
            {
              text: '商机淘金助手',
              href:'//www.5118.com/niche'
            },
            {
              text: '标题助手',
              href:'//www.5118.com/titleoptimizer'
            },
            {
              text: '商机风险分析师',
              href:'//www.5118.com/cleverbiz'
            },
            {
              text: '竞价广告创意大师',
              href:'//www.5118.com/bidadsmaster'
            },
            {
              text: '落地页内容构造器',
              href:'//www.5118.com/landingpage'
            },
            {
              text: 'AI短视频编剧',
              href:'//www.5118.com/vidscripter'
            },
            {
              text: '问答营销助手',
              href:'//www.5118.com/ai/qamarketing'
            },
            {
              text: 'SEO优化精灵：一键式文章助手',
              href:'//www.5118.com/ai/articlegenius'
            },
             {
              text: '5118批量任务管家',
              href:'//task.5118.com'
            }
          ],
        };
    },
  computed: {},
  methods: {},
};
</script>

<style type="text/less" lang="less" scoped>

.dropdown_box {
    position: relative;
    display: inline-block;
    height: 58px;
    line-height: 58px;
   
    .dropbtn_box {
      padding: 0 20px;
      line-height: 58px;
      color: #e3e5ec;
      display: initial;
      cursor: pointer;
      font-size: 14px;
       font-weight: bold;
       display: block;
      .shareIcon {
          width: 12px;
          height: 7px;
          background: url(../../assets/image/xin_img.png) center center no-repeat;
          vertical-align: middle;
          display: inline-block;
          margin-top: -2px;
          margin-left: 4px;
      }
  }
}

.dropdown-content-box {
    display: none;
    border: 1px solid #0C7DF5;
    position: absolute;
    background-color: white;
    min-width: max-content;
    box-shadow: 0px 8px 16px 0px rgba(12,125,245,0.2);
    z-index: 1000;
    border-radius: 6px;
    top: 48px;
    left: 18px;
    text-align: left;
    padding: 5px 0;

    a {
        color: black;
        padding: 0 12px;
        text-decoration: none;
        display: block;
        line-height: 30px;
        color: #0C7DF5;
        font-size: 14px;
    }

    :hover {
        background-color: #f1f1f1;
    }
}
.dropdown_box:hover .dropdown-content-box {
    display: block;
}
</style>
